interface ObjectLiteral {
  [key: string]: any;
}

export const convertObjectToFormData = (obj: ObjectLiteral) => {
  const newFormData = new FormData();
  Object.entries(obj).forEach(([key, value]) => {
    newFormData.append(key, value);
  });
  return newFormData;
};
